import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({

  consultarContribuicaoMaximaRequest: ["salarioParticipacao"],
  atualizarContribuicaoMaxima: ["contribuicaoMaxima"],
  atualizarContribuicaoBasica: ["contribuicaoBasica"],
  consultarSimulacaoRequest: ["simulacao"],
  atualizarSimulacao: ["simulacao"],
  simuladorPrevidenciaSuccess: [],
  consultarContribuicaoBasica: ["body"],
  simuladorPrevidenciaFailure: ["error"],
});

export const SimuladorPrevidenciaTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  loading: false,
  error: "",
  contribuicaoMaxima: "",
  contribuicaoBasica: "",
  simulacao: {}
});

export const reducer = createReducer(INITIAL_STATE, {

  [Types.SIMULADOR_PREVIDENCIA_SUCCESS]: (state) =>
    state.merge({
      error: "",
      loading: false,
    }),

  [Types.SIMULADOR_PREVIDENCIA_FAILURE]: (state, { error }) =>
    state.merge({ error, loading: false }),

  [Types.CONSULTAR_CONTRIBUICAO_MAXIMA_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.ATUALIZAR_CONTRIBUICAO_BASICA]: (state, { contribuicaoBasica }) =>
    state.merge({ contribuicaoBasica }),  

  [Types.CONSULTAR_CONTRIBUICAO_BASICA]: (state) =>
    state.merge({ loading: true }),

  [Types.CONSULTAR_SIMULACAO_REQUEST]: (state) =>
    state.merge({ loading: true }),

  [Types.ATUALIZAR_CONTRIBUICAO_MAXIMA]: (state, { contribuicaoMaxima }) =>
    state.merge({ contribuicaoMaxima }),

  [Types.ATUALIZAR_SIMULACAO]: (state, { simulacao }) => 
    state.merge({ simulacao }),

});
